export default __webpack_public_path__ + "images/extensionPromoDark_7abbf7.png";